module.exports = __webpack_public_path__ + "img/video.1759d026.png";